import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import * as unitFiltersApi from "../../services/unit_filters";
import Button from "../../components/Button";
import "../../styles/reviews.css";

function AddUnitFiltersPage() {
  const history = useHistory();
  const [form, setForm] = useState({ name: "", filter_key: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (!form.name.trim()) errors.name = "Name is required";
    if (!form.filter_key.trim()) errors.filter_key = "Filter Key is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length) {
      setError(Object.values(errors).join(". "));
      return;
    }
    setLoading(true);
    setError("");
    try {
      await unitFiltersApi.createUnitFilter(form);
      history.push("/unit-filters");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to add unit filter");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <div className="container" style={{ maxWidth: 600 }}>
        <Button title="Back" typeBtn="secondary" onPress={() => history.push("/unit-filters")} />
        <h2 className="mt-3 mb-3">Add Unit Filter</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-2">
            <label>Filter Name</label>
            <input name="name" className="form-control" value={form.name} onChange={handleChange} required />
          </div>
          <div className="form-group mb-2">
            <label>Filter Key</label>
            <input name="filter_key" className="form-control" value={form.filter_key} onChange={handleChange} required />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <Button title={loading ? "Saving..." : "Add Unit Filter"} type="submit" typeBtn="primary" disabled={loading} />
        </form>
      </div>
    </div>
  );
}

export default AddUnitFiltersPage;
